module.exports = __webpack_public_path__ + "img/image_slide5_3.952b0cff.png";